<template>
  <el-dialog class="reset-modal" width="500px" :visible.sync="visible">
    <h2 slot="title" class="modal-header-title">修改密码</h2>
    <div class="content">
      <div class="user-info-content">
        <div class="header-img">
          <img class="img" src="@/assets/images/avatar.png">
        </div>
        <!--<div class="user-info-item">-->
          <!--<label class="label-item">用户名：</label>-->
          <!--<div class="info-item text-indent">{{userInfo.accountName}}</div>-->
        <!--</div>-->
        <!--<div class="user-info-item">-->
          <!--<label class="label-item">手机号码：</label>-->
          <!--<div class="info-item text-indent">{{userInfo.mobile || '无'}}</div>-->
        <!--</div>-->
        <el-form @submit.native.prevent @keydown.native.enter="onClickSave"  status-icon :model="ruleForm" label-width="100px" :rules="rules" ref="ruleForm">
          <el-form-item label="用户名：" >
            {{userInfo.accountName}}
          </el-form-item>
          <el-form-item label="手机号码：">
            {{userInfo.mobile || '无'}}
          </el-form-item>
          <el-form-item label="旧密码：" prop="oldPassWord" :error="oladPasswordError">
            <el-input size="medium"  v-model="ruleForm.oldPassWord" :max="25" type="password"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPassword">
            <el-input size="medium" v-model="ruleForm.newPassword" :max="25" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="confirmPassword">
            <el-input size="medium" v-model="ruleForm.confirmPassword" :max="25" type="password"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="onClickSave" type="primary">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import types from '@/store/types'
export default {
  props: {
    value: Boolean
  },
  computed: mapGetters(['userInfo']),
  data () {
    return {
      visible: false,
      oladPasswordError: '',
      rules: {
        oldPassWord: [
          {required: true, message: '请输入旧密码', trigger: 'blur'},
          { min: 6, max: 25, message: '密码长度在 6 到 25 个字符', trigger: 'blur' }
        ],
        newPassword: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          { min: 6, max: 25, message: '密码长度在 6 到 25 个字符', trigger: 'blur' },
          {validator: this.checkPasswordFormat, trigger: 'change'}
        ],
        confirmPassword: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          { min: 6, max: 25, message: '密码长度在 6 到 25 个字符', trigger: 'blur' },
          {validator: this.checkPassWord, trigger: 'change'}
        ]
      },
      ruleForm: {
        oldPassWord: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  watch: {
    visible (val) {
      this.ruleForm.oldPassWord = ''
      this.ruleForm.newPassword = ''
      this.ruleForm.confirmPassword = ''
      this.$emit('input', val)
    },
    value (val) {
      this.visible = val
    }
  },
  methods: {
    onClickSave () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api('base/updateUserPassword', {
            oldPwd: this.ruleForm.oldPassWord,
            accountPwd: this.ruleForm.newPassword
          })().then(data => {
            this.visible = false
            this.$message.success(data.msg)
            this.$store.dispatch(types.user.LOGOUT).then(() => {
              this.$router.push({
                name: 'login'
              })
            })
            this.oladPasswordError = ''
          }).catch(err => {
            this.oladPasswordError = (err.data && err.data.msg) || err.msg
            // this.$set.error(err.data.msg || err.msg)
          })
        }
      })
    },
    checkPassWord (rule, value, callback) {
      if (this.ruleForm.newPassword !== value) {
        return callback(new Error('两次输入的密码不一致'))
      }
      return callback()
    },
    checkPasswordFormat(rule, value, callback){
      let patt = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/)
      if(!patt.test(value)){
        return callback(new Error('密码格式错误：密码格式必须包含数字和字母'))
      }
      return callback()
    }
  }
}
</script>

<style lang="scss">
  .reset-modal {
    .jc-modal {
      width: 460px;
      .jc-modal-footer {
        line-height: 1;
      }
    }
    .modal-header-title {
      line-height: 1;
      font-size: 16px;
    }
  }
  .content {
    .user-info-content {
      .header-img {
        width: 60px;
        margin: 20px auto;
        height: 58px;
        border-radius: 40px;
        * {
          width: 100%;
          height: 100%;
          border-radius: 40px;
        }
      }
      width: 400px;
      margin: auto;
      /*.user-info-item {*/
        /*padding: 15px 0;*/
        /*.label-item {*/
          /*width: 26.3%;*/
          /*display: inline-block;*/
          /*text-align: right;*/
          /*.check {*/
            /*color: red;*/
            /*display: inline-block;*/
            /*padding: 4px;*/
          /*}*/
        /*}*/
        /*.info-item {*/
          /*width: 71%;*/
          /*display: inline-block;*/
          /*padding-left: 10px;*/
        /*}*/
        /*.text-indent {*/
          /*text-indent: 1em;*/
        /*}*/
      /*}*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/main/components/user/reset.vue